import { JsonFormsDispatch, withJsonFormsLayoutProps } from "@jsonforms/react";
import "./section-group-layout.scss";

const SectionGroupLayout = ({
  schema,
  uischema,
  path,
  renderers,
  cells,
  enabled,
}) => {
  return (
    <div
      className="display-flex flex-direction-row
     gap-8 section-group-layout"
      data-testid="section-group-layout"
    >
      {uischema.label && (
        <div className="font-body-bold section-title" data-testid="section-title">
          {uischema.label}
        </div>
      )}
      <div className="grid-item" data-testid="section-group-grid">
        {uischema.elements.map((element, index) => (
          <JsonFormsDispatch
            schema={schema}
            uischema={element}
            path={path}
            enabled={enabled}
            renderers={renderers}
            cells={cells}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export const SectionGroupLayoutControl =
  withJsonFormsLayoutProps(SectionGroupLayout);
